import { IconButton, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { MdViewStream, MdViewHeadline } from 'react-icons/md';
import { TableDensity, getTableDensity, setTableDensity } from '../../theme/chart-config';
import { useState } from 'react';
import { translate } from '../../i18n';

interface TableDensityToggleProps {
	tableId: string;
	onChange?: (density: TableDensity) => void;
}

/**
 * Small icon button to toggle between comfortable (2-line) and dense (3-line) table density.
 * Persists per-table in localStorage.
 */
export default function TableDensityToggle({ tableId, onChange }: TableDensityToggleProps) {
	const [density, setDensity] = useState<TableDensity>(() => getTableDensity(tableId));
	const iconColor = useColorModeValue('secondaryGray.600', 'secondaryGray.500');
	const hoverBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

	const toggle = () => {
		const next: TableDensity = density === 'comfortable' ? 'dense' : 'comfortable';
		setDensity(next);
		setTableDensity(tableId, next);
		onChange?.(next);
	};

	const label = density === 'comfortable'
		? (translate('common.compact' as any) || 'Compact view')
		: (translate('common.comfortable' as any) || 'Comfortable view');

	return (
		<Tooltip label={label} hasArrow placement='top'>
			<IconButton
				aria-label={label}
				icon={density === 'comfortable'
					? <MdViewHeadline size='18px' />
					: <MdViewStream size='18px' />
				}
				size='sm'
				variant='ghost'
				color={iconColor}
				_hover={{ bg: hoverBg }}
				onClick={toggle}
			/>
		</Tooltip>
	);
}
